module.exports = " <button class=btn :disabled=disabled :class=\"{ hidden: hidden, inactive: inactive }\" type=submit _v-7c79a226=\"\"> <slot _v-7c79a226=\"\"></slot> </button> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-7c79a226!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Btn.vue
// module id = 327
// module chunks = 2